import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Monitor, Smartphone, ExternalLink, Store, User } from "lucide-react";

export function CartPreviewPanel({ slug }) {
  const [view, setView] = useState("storefront"); // storefront | portal
  const [device, setDevice] = useState("desktop");
  const isMobile = device === "mobile";
  const isPortal = view === "portal";
  const url = isPortal ? `/preview/${slug}?view=portal` : `/preview/${slug}`;

  const seg = (active) =>
    `px-3 py-1.5 text-sm flex items-center gap-2 transition-colors ${active ? "bg-primary text-primary-foreground" : "bg-background hover:bg-muted"}`;

  return (
    <div data-testid="cart-preview-panel">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3">
        {/* view toggle */}
        <div className="inline-flex border border-border overflow-hidden">
          <button onClick={() => setView("storefront")} data-testid="preview-view-storefront" className={seg(!isPortal)}>
            <Store className="h-4 w-4" /> Storefront &amp; Cart
          </button>
          <button onClick={() => setView("portal")} data-testid="preview-view-portal" className={seg(isPortal)}>
            <User className="h-4 w-4" /> Customer Portal
          </button>
        </div>

        <div className="flex items-center gap-3">
          {/* device toggle */}
          <div className="inline-flex border border-border overflow-hidden">
            <button onClick={() => setDevice("desktop")} data-testid="preview-device-desktop" className={seg(!isMobile)}>
              <Monitor className="h-4 w-4" /> Desktop
            </button>
            <button onClick={() => setDevice("mobile")} data-testid="preview-device-mobile" className={seg(isMobile)}>
              <Smartphone className="h-4 w-4" /> Mobile
            </button>
          </div>
          <Button variant="outline" size="sm" className="rounded-none gap-2" data-testid="preview-open-fullpage" onClick={() => window.open(url, "_blank")}>
            <ExternalLink className="h-4 w-4" /> Open full-page
          </Button>
        </div>
      </div>

      <div className="border border-border bg-muted/30 flex justify-center p-4">
        <iframe
          key={view + device}
          title="MorrCart live preview"
          src={url}
          data-testid="cart-preview-iframe"
          style={{ width: isMobile ? 390 : "100%", height: 560, border: "1px solid #e5e5e5", background: "#fff", transition: "width .25s ease" }}
        />
      </div>

      <p className="text-xs text-muted-foreground mt-2">
        {isPortal
          ? "The customer account portal exactly as it appears on your site (login → orders → loyalty)."
          : "Your storefront & cart using your real products and settings. Orders placed here are real and appear on your Board."}
      </p>
    </div>
  );
}
